import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";
import Restriction from "./Restriction";
const defaultAutos = {
  Branches: [],
};

export default function RestrictionOpenCon(props ) {
    const [branch, setBranch] = useState({ id: -1, name: "الكل" });
    const tttb = {
        wait: true,
        other: true,
        costcenters: true,
        branches: true,
        omlat: true,
        UsersA: true,
        AccountBooks: true,
        PermissionsElemnts: true,
        stor: { ...sto, branchi: branch.id == -1 ? sto.branchi : branch.id },

        parms: {
          ibranchid: branch.id == -1 ? sto.branchi : branch.id ,
          iempid: sto.empi,
          iuserid: sto.idi,
          branch:  branch.id == -1 ? sto.branchi : branch.id ,
          tname: "rest",
          withOmlat: true,
          iformid: "60012",
        },
        autos: {
          branches: true,
          costcenters: true,
          AccountBooks: true,
          omlat: true,
        },
      };
    

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "Res",
    tttb,
    [branch]
  );

  const tb2 = {
    wait:true,
    AccountsIndex: true,
    stor: sto,
    parms:{
        iempid: sto.empi,
        branch:sto.branchi,
    },
};

const { object: Accounts} = useFetchObjectByPost(
    uri + "GetD",
    tb2,
  );


  if (
    fetchAll ||
    !Accounts||
    !AutoOptions?.Branches||
    !AutoOptions?.costcenters 
  )
    return <LoadingPage />;

  return (

    <Restriction
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
        branch,
        setBranch,
        IsOpen:true,
        isDialog: false,
        isDialogData: false,
        Accounts
      }}
    />
  );
}
